<template>
  <div class="info-container">
    <div class="info-title-section">
      <div class="left">{{ $t("审核中") }}</div>
    </div>
    <div class="content">
      <div v-if="type == 1">
        <img src="@/imgs/user/status1.png" class="img" />
        <div class="status">{{ $t("审核中") }}</div>
      </div>
      <div v-if="type == 2">
        <img src="@/imgs/user/status2.png" class="img" />
        <div class="status">{{ $t("审核失败") }}</div>
        <div class="reason">{{ reason }}</div>
        <div class="ul">
          <span class="li" @click="toAgain">{{ $t("重新申请") }}</span>
          <span class="li" @click="kf">{{ $t("联系客服") }}</span>
          <span class="li" @click="$router.push('/user')">{{ $t("放弃申请") }}</span>
        </div>
      </div>
      <button class="btn" @click="back">{{ $t("返回") }}</button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["type", "reason"],
  data() {
    return {
      // type: null, //1 审核中 2 审核失败
    };
  },
  mounted() {
    // this.type = this.$route.query.type
  },
  methods: {
    kf() {
      location.href =
        "https://104910.kefu.easemob.com/webim/im.html?configId=374e3e7d-7239-4ae7-bb29-fe5ba4c62898";
    },
    back() {
      this.$router.back();
    },
    toAgain() {
      this.$emit("again");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "themePath/user";
.content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 20px;
  .img {
    height: 192px;
    margin-top: 79px;
  }
  .status {
    font-size: 24px;
    margin-top: 24px;
    font-weight: bold;
    text-align: center;
  }
  .reason {
    width: 288px;
    font-size: 16px;
    color: #999;
    margin-top: 8px;
    text-align: center;
    word-wrap: break-word;
    // overflow:hidden;
    // white-space: nowrap;
    // text-overflow: ellipsis;
    // -o-text-overflow:ellipsis;
    //  overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    word-break: break-all;
    // -webkit-box-orient: vertical;
  }
  .ul {
    display: flex;
    margin-top: 24px;
    .li {
      font-size: 18px;
      color: #666;
      cursor: pointer;
      &:nth-child(2) {
        margin: 0 24px;
      }
    }
  }
  .btn {
    width: 156px;
    height: 56px;
    border-radius: 4px;
    border: 1px solid #bfbfbf;
    text-align: center;
    line-height: 54px;
    font-size: 18px;
    color: #999;
    background-color: #fff;
    margin-top: 32px;
    box-sizing: border-box;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/user/sqStatus.vue